import { render, staticRenderFns } from "./FormTag.vue?vue&type=template&id=b10e78b2&scoped=true&"
import script from "./FormTag.vue?vue&type=script&lang=js&"
export * from "./FormTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10e78b2",
  null
  
)

export default component.exports